import { makeStyles } from '@material-ui/core'

export const useSidebarStyles = makeStyles((theme) => ({
  accordionContentContainer: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  accordionContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    flexGrow: 1,
  },
  buttonContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
  },
  accordionTopMargin: {
    marginTop: theme.spacing(4),
  },
  autoCompleteField: {
    maxWidth: '285px',
  },
}))
